import { render, staticRenderFns } from "./ConversationsManagement.vue?vue&type=template&id=3903a899&scoped=true&"
import script from "./conversations-management.ts?vue&type=script&lang=ts&"
export * from "./conversations-management.ts?vue&type=script&lang=ts&"
import style0 from "./conversations-management.scss?vue&type=style&index=0&id=3903a899&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3903a899",
  null
  
)

export default component.exports